import { inject, Injectable, NgZone } from '@angular/core';
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';

import * as AppActions from './app.actions';
import { AppStateService } from './services/app-state.service';

import type { RootState } from '../../background-service-worker/services/extension-store/extension.store';

@Injectable()
export class AppEffects {
  private appStateService = inject(AppStateService);

  private zone = inject(NgZone); // Inject NgZone

  constructor(private actions$: Actions) {}

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.appStateService.loadState()),
      // Wrap the action dispatch in NgZone.run()
      switchMap((appState: RootState) =>
        this.zone.run(() => of(AppActions.loadAppSuccess({ app: { settings: appState } })))
      ),
      catchError(
        (error) => this.zone.run(() => of(AppActions.loadAppFailure({ error: error as string }))) // Also wrap error action
      )
    )
  );

  sync$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.syncAppState),
      switchMap(() => this.appStateService.loadState()),
      // Wrap the action dispatch in NgZone.run()
      switchMap((appState: RootState) =>
        this.zone.run(() => of(AppActions.loadAppSuccess({ app: { settings: appState } })))
      ),
      catchError(
        (error) => this.zone.run(() => of(AppActions.loadAppFailure({ error: error as string }))) // Also wrap error action
      )
    )
  );
}
